import './ui.css';
import type { ReactNode } from 'react';
import { Icon, type IconName } from './icons';

export interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  message?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, message, action }: EmptyStateProps) {
  return (
    <div className="ui-empty">
      {icon && <Icon name={icon} size={40} className="ui-empty__icon" />}
      <p className="ui-empty__title">{title}</p>
      {message && <p className="ui-empty__msg">{message}</p>}
      {action}
    </div>
  );
}

export function Spinner({
  size = 'md',
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const cls = ['ui-spinner', size !== 'md' && `ui-spinner--${size}`, className]
    .filter(Boolean)
    .join(' ');
  return <span className={cls} role="status" aria-label="Loading" />;
}

export function Loading({ label = 'Loading…' }: { label?: ReactNode }) {
  return (
    <div className="ui-loading">
      <Spinner size="sm" />
      {label}
    </div>
  );
}
